import React from "react";
import { useTranslation } from "next-i18next";
import { IWikifolioAlphaKeyFigureGroupSection } from "src/api/server/wf-detail.types";
import { Typography } from "src/components-mui/base/typography/typography";
import { AlphaWithPerformanceValue } from "src/components-mui/pages/detail/key-figures/components/alpha/alpha-with-performance-value";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";

interface ISecondBestAlphaProps {
    creationDate: string;
    alpha: IWikifolioAlphaKeyFigureGroupSection["secondBestAlpha"];
}

export const SecondBestAlpha = ({ alpha, creationDate }: ISecondBestAlphaProps) => {
    const { t } = useTranslation("wf-detail");
    const { formatDateShort } = useDateTimeFormatter();

    const text = alpha.useCreationDate
        ? t("alpha.second-best-alpha-since", {
              0: alpha.benchmarkName,
              1: formatDateShort(creationDate),
          })
        : t("alpha.second-best-alpha-years", {
              0: alpha.benchmarkName,
              1: alpha.timespanYears,
          });

    return (
        <Typography>
            <AlphaWithPerformanceValue value={alpha.alphaEstimateAnnualized} text={text} />
        </Typography>
    );
};
